import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component';
import { TableHandler } from '../../../../../classes';

@Component({
  selector: 'question-table-checkbox',
  templateUrl: './question-table-checkbox.component.html',
  styleUrls: ['./question-table-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTableCheckboxComponent extends QuestionComponent {
  get table(): TableHandler {
    return this.question.table;
  }
  ngOnInit() {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  refreshView() {
    super.refreshView();
  }

  trackByIndexFn(index: number, val) {
    return index;
  }
  trackByIdFn(index: number, val: any) {
    return val.id;
  }
}
